import { isNil } from 'lodash';
import { PhoneNumber } from '@/@types/member';

export default function(phoneNumber: PhoneNumber): string {
  if (isNil(phoneNumber)) {
    return '';
  }
  return `${phoneNumber.areaCode ? phoneNumber.areaCode : ''}${
    phoneNumber.exchangeCode ? phoneNumber.exchangeCode : ''
  }${phoneNumber.lineNumber ? phoneNumber.lineNumber : ''}`;
}
